import { render, staticRenderFns } from "./ContactFieldset.vue?vue&type=template&id=6ff39a25&scoped=true"
import script from "./ContactFieldset.vue?vue&type=script&lang=js"
export * from "./ContactFieldset.vue?vue&type=script&lang=js"
import style0 from "./ContactFieldset.vue?vue&type=style&index=0&id=6ff39a25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff39a25",
  null
  
)

export default component.exports